var initialState = {
    id:104,
    type: 'quiz',
    user_id: -1,
    title: '',
    description: '',
    questions: []
};

const storeQuizForEditing = (state = initialState, action) => {
    switch(action.type){
        case 'STORE_QUIZ_FOR_EDITING':
            return state = {...action.payload};
        default:
            return state;
    }
}
export default storeQuizForEditing;